import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import * as lookup from "../../../static/lookup.json"
import Select from "react-select"
import { components } from "react-select"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import {JourneyContext} from "../context/journeyContext"
import { getValueFromLookup, productRenderChecker, getValueFromJourney } from "../services/helperFunctions"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { lineCapital } from "../../shared/functions"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 1rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};
// const customStyles = {
//   option: (provided) => ({
//     ...provided,
//     // padding: 0,
//     zIndex:9999
//   }),
//   control: () => ({
//     // display:'flex'
//     // none of react-select's styles are passed to <Control />
//   }),
//   input:()=>({

//   }),
//   singleValue: (provided, state) => {
//     // const opacity = state.isDisabled ? 0.5 : 1;
//     // const transition = 'opacity 300ms';

//     // return { ...provided, opacity, transition };
//   }
// }

export default function ComponentTextMultiSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const validate = (target) =>  {
    if(props.data.required){ // required field validation
      if(sectionState.sectionData && ((sectionState.sectionData[props.data.formControlKey]?.length === 0) || (!sectionState.sectionData[props.data.formControlKey]))){
        setErrorState( prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
            ? (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            )): `Error Code Not Found in Strapi`,
          })
        })
      } else{
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: []
          })
        })
      }
      if(target.value){
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: []
          })
        })
      }
    }
    console.log(sectionState.sectionData[props.data.formControlKey], "khsbdhjbdscs")
    if(sectionState.sectionData[props.data.formControlKey] && ((sectionState.sectionData[props.data.formControlKey].length > 5))) {
      setErrorState( prev => {
        return ({
          ...prev,
          [props.data.formControlKey]: `Please select maximum of 5 countries`
        })
      })
    }
    return
  }

  useEffect(() => {
    validate({value: sectionState.sectionData?.[props.data.formControlKey]?? ""})
    console.log(props?.data?.formControlKey,['1','2','D'].includes(sectionState.sectionData?.[props.data.formControlKey]), sectionState.sectionData?.[props.data.formControlKey] )
    
  },[sectionState.sectionData?.[props.data.formControlKey]])
  
  //To select value to india for as country code
  useEffect(() => {
   /*  if(!sectionState.sectionData?.[props.data.formControlKey]){
      if(props.data.defaultValue){ // remove this condition && props.sectionId === "CPPersonalDetailsSection"  === "contactCountryCode"
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: props.data.defaultValue
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.defaultValue,
          }
        })
      }
      // else if(props.data.formControlKey === "AppointeeFullNameTitle"){
      //   setSectionState((prev) => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         [props.data.formControlKey]: "MR"
      //       },
      //     })
      //   })
      //   setConditionState(prev => {
      //     return {
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "MR",
      //     }
      //   })
      // }

      if((conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] === "+91" || conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] === "+91" ) && props.sectionId !== "CPPersonalDetailsSection"){
        if(props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "+91"
              },
            })
          })
        }
        else if(props.data.formControlKey != "countryCode" && props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "IN",
            }
          })
        }else if(props.data.formControlKey === "residentStatus"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "N"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "N",
            }
          })
        }
      }else{
        if(props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: props.journeyIdFromStrapi === "iSelectJourney" ? conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] : props.journeyIdFromStrapi === "ISelect360Journey" ? conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] : "+91"
              },
            })
          })
        }else if((props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality") && props.sectionId !== "CPPersonalDetailsSection" && props.sectionId !== "SectionGuaranteedSavingPersonaldetails" && props.sectionId !== "SectionPOSNomineeDetails"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: props.journeyIdFromStrapi === "iSelectJourney" ? getValueFromLookup("countryCodeToCountry", conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"]) : props.journeyIdFromStrapi === "ISelect360Journey" ? getValueFromLookup("countryCodeToCountry", conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"]): "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.journeyIdFromStrapi === "iSelectJourney" ? getValueFromLookup("countryCodeToCountry", conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"]) : props.journeyIdFromStrapi === "ISelect360Journey" ? getValueFromLookup("countryCodeToCountry", conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"]): "IN",
            }
          })
          autoFill({})
        }else if(props.data.formControlKey === "residentStatus"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "Y"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "Y",
            }
          })
        }
      }
      
    } */
    
  }, [props.sectionId])

  const handleChange = target => {
    let targetValue = target.map(ele => {return ele.value})
    if (sectionState.sectionId === props.sectionId) {
        console.log(sectionState, 'myprop12')
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: targetValue
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: targetValue,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")
    validate(target)
    if(props.saveApplicationAndCallBi){
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }
    // console.log(sectionState, "section state")
  }

  const isValidNewOption = (a,b) => {
      console.log("hi1111")
      return false
  }

  const autoFill = (target) => {
  }

  // const getSelectedValue = () => {
  //   let key = Object.keys(props.options).filter(function(key) {return props.options[key] === sectionState.sectionData[props.data.formControlKey] })[0];
  //   console.log(key,"dhbe")
  //   return key
  // }
  function getKeyByValue(object, multiValue) {
    let temp = []
    multiValue.forEach(element => {
      temp.push(object.find(key => key.value == element))
    })
    console.log(temp, "autofillValue")
    return temp
  }
  let options = props.options
  options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: val,
  }))
  return (
    <>
      <SelectContainer channel={props.channel} className={`input-container ${props.data.disabled?'disable-input':''} ${props.data?.freeze?'freeze-input':''}` }>
        <label htmlFor={props.data.label} className="input-label">
        {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
        </label>
        <Select
          // className="form-control"
          // styles={customStyles}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          isDisabled={false}
          isMulti
          allowSelectAll={true}
          onChange={handleChange}
          options={options}
          components={{Option}}
          //name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelectMulti"
          required={props.data.required}
          className={props.data.disabled?"disable-input":""}
          tabIndex={props.data.disabled || props.data?.freeze?-1:0}
          // value={
          //   sectionState.sectionData[props.data.formControlKey]
          //     ? getKeyByValue(
          //         options,
          //         sectionState.sectionData[props.data.formControlKey]
          //       )
          //     : ""
          // }
          value={
            sectionState.sectionData?.[props.data.formControlKey]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey]
                )
              : ""
          }
          onBlur={e => autoFill(e.target)}
        />
        <span className="input-error2">
          {props.showError && errorState[props.data.formControlKey]}
        </span>
      </SelectContainer>
    </>
  )
}
